









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CompanyDocument } from '@/store/models';
import * as api from '@/store/api';

@Component({ components: {} })
export default class DocumentPresentation extends Vue {
  @Prop() readonly doc!: CompanyDocument;

  showComments: boolean = false;
  showEditor: boolean = false;
  comments: any = null;

  @Watch('doc', {immediate: true, deep: true})
  onData() {
    api.getDocumentComments(this.doc.DocumentId).then((x: any) => {
      this.comments = x;
      this.showComments = x.ShowComments;
      this.showEditor = x.ShowEditor;
    });
  }

  @Watch('showComments', {immediate: false, deep: false})
  onData2() {
    if (!this.comments || this.showComments === this.comments.ShowComments) {
      return;
    }
    this.comments.ShowComments = this.showComments;
    api.updateDocumentComments(this.comments);
  }

  @Watch('showEditor', {immediate: false, deep: false})
  onData3() {
    if (!this.comments || this.showEditor === this.comments.ShowEditor) {
      return;
    }
    this.comments.ShowEditor = this.showEditor;
    api.updateDocumentComments(this.comments);
  }

}
